export default {
  parseNumberOrZero(numero) {
    const valorConvertido = parseInt(numero, 10)
    return isNaN(valorConvertido) ? 0 : valorConvertido
  }
}
